import React from 'react';
import './css/About.css';
import BannerImage from './BannerImage.jsx';

const STATS = [
  { num: '46+', label: 'Years of Experience', desc: 'Founded in 1980, Ludhiana, Punjab' },
  { num: '25+', label: 'States Served', desc: 'Strong pan-India presence' },
  { num: '2000+', label: 'Products', desc: 'Widest range under one roof' },
  { num: '100%', label: 'Quality Focus', desc: 'Zero compromise on standards' },
];

const VALUES = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="28" height="28">
        <circle cx="12" cy="12" r="3"/>
        <path d="M12 2v3M12 19v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M2 12h3M19 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12"/>
      </svg>
    ),
    title: 'Precision Engineering',
    desc: 'Stringent quality controls and precise specifications ensure exceptional performance and reliability in every component.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="28" height="28">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
      </svg>
    ),
    title: 'Uncompromising Quality',
    desc: 'Quality is at the core of everything we do. We never compromise on materials, workmanship, or product standards.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="28" height="28">
        <circle cx="12" cy="12" r="10"/>
        <path d="M2 12h20M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20"/>
      </svg>
    ),
    title: 'Pan-India & Global Reach',
    desc: 'Serving customers across 25+ states in India while steadily expanding our international export presence.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="28" height="28">
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
      </svg>
    ),
    title: 'Customer-First Philosophy',
    desc: 'Lasting success comes from understanding customer needs, delivering consistent value, and building long-term trust.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="28" height="28">
        <rect x="1" y="3" width="15" height="13" rx="1"/>
        <path d="M16 8h4l3 3v5h-7V8z"/>
        <circle cx="5.5" cy="18.5" r="2.5"/>
        <circle cx="18.5" cy="18.5" r="2.5"/>
      </svg>
    ),
    title: 'Fast & Reliable Dispatch',
    desc: 'Efficient manufacturing and supply chain processes enable timely deliveries and dependable service every time.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="28" height="28">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        <path d="M9 12l2 2 4-4"/>
      </svg>
    ),
    title: 'Pioneer in Fasteners',
    desc: 'Among the established names that shaped India\'s automotive fastener industry since 1980.',
  },
];

const PRODUCTS = [
  { cat: 'Automotive Fasteners', items: ['Nuts & Bolts (Standard & Specialty)', 'Screws & Washers', 'Special Fasteners & Threaded Components'] },
  { cat: 'Two-Wheeler Spare Parts', items: ['Springs', 'Chain Adjusters', 'Wheel Axles', 'Side Stands', 'Fork Racer Sets', 'Kick Lever Assemblies', 'Gear Lever Assemblies', 'Brake Rod Assemblies'] },
  { cat: 'Custom Solutions', items: ['Customized Fastening Solutions', 'OEM-Spec Components', 'Precision Automotive Parts'] },
];


const HIGHLIGHTS = [
  { num: '46+', text: 'Years Experience — Founded in 1980, decades of industry leadership.' },
  { num: '25+', text: 'States Served — Strong presence across India\'s automotive market.' },
  { num: '2000+', text: 'Products — Extremely wide range of fasteners and components.' },
  { num: '100%', text: 'Quality Focus — Strict standards with zero compromise.' },
];

export default function About() {
  return (
    <div className="about-container-root">

      {/* ── HERO BANNER ── */}
      <section
        className="products-hero-banner"
        style={{ width: '100%', backgroundColor: '#0E0E0E', overflow: 'hidden' }}
      >
        <BannerImage
          src="/banners/ABOUT PAGE WALNUT.png"
          alt="Walnut Industries About Us"
          style={{ width: '100%' }}
          imageStyle={{ height: 'auto' }}
          fallbackText="About Banner"
        />
      </section>

      {/* ── INTRO / STORY SECTION ── */}
      <section className="story-section">
        <div className="story-grid">
          <div className="story-left">
            <div className="story-tag">Est. 1980 · Ludhiana, Punjab, India</div>
            <h2>Precision. Quality.<br />Trust. <span className="red">Since 1980.</span></h2>
            <p>
              Established in Ludhiana, Punjab, we are a leading manufacturer and exporter of automotive fasteners
              and two-wheeler spare parts with over <strong>46 years of industry expertise.</strong> As one of the
              pioneers in the automotive fastener segment, we have built a strong reputation for quality,
              precision, reliability, and customer satisfaction.
            </p>
            <p>
              Over the decades, our commitment to excellence has enabled us to become a trusted name across
              India and international markets. Today, our products are supplied across more than
              <strong> 25 states in India</strong> and to customers worldwide, serving the evolving needs
              of the automotive industry.
            </p>
            <div className="story-badges">
              <div className="story-badge">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>
                ISO Certified Manufacturing
              </div>
              <div className="story-badge">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 010 20"/></svg>
                Global Export Ready
              </div>
              <div className="story-badge">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                OEM Grade Quality
              </div>
            </div>
          </div>
          <div className="story-right">
            <img
              src="/resources/walnut-store.png"
              alt="Walnut Industries Factory"
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <section className="stats-section">
        <div className="stats-grid">
          {STATS.map((s, i) => (
            <div className="stat-card" key={i}>
              <span className="stat-num">{s.num}</span>
              <span className="stat-label">{s.label}</span>
              <span className="stat-desc">{s.desc}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── PRODUCT RANGE ── */}
      <section className="product-range-section">
        <div className="section-header">
          <h2>OUR PRODUCT RANGE</h2>
          <p className="section-sub">
            One of the widest ranges in the automotive fasteners and components industry — all under one roof.
          </p>
        </div>
        <div className="product-range-grid">
          {PRODUCTS.map((cat, i) => (
            <div className="range-card" key={i}>
              <h4 className="range-cat-title">{cat.cat}</h4>
              <ul className="range-list">
                {cat.items.map((item, j) => (
                  <li key={j}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="12" height="12">
                      <polyline points="20 6 9 17 4 12"/>
                    </svg>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
      {/* ── VALUES / WHAT SETS US APART ── */}
      <section className="values-section">
        <div className="section-header">
          <h2>WHAT SETS US APART</h2>
          <p className="section-sub">
            Nearly five decades of experience and a relentless focus on quality define who we are.
          </p>
        </div>
        <div className="values-grid">
          {VALUES.map((v, i) => (
            <div className="value-card" key={i}>
              <div className="value-icon">{v.icon}</div>
              <h3>{v.title}</h3>
              <p>{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── VISION & MISSION ── */}
      <section className="vision-mission-section">
        <div className="vm-grid">
          <div className="vm-card vision">
            <div className="vm-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="32" height="32">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
            </div>
            <h3>Our Vision</h3>
            <p>
              To be the preferred global partner for automotive fasteners and precision-engineered components,
              recognized for our commitment to quality, innovation, and customer satisfaction.
            </p>
          </div>
          <div className="vm-card mission">
            <div className="vm-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="32" height="32">
                <circle cx="12" cy="12" r="10"/>
                <circle cx="12" cy="12" r="6"/>
                <circle cx="12" cy="12" r="2"/>
              </svg>
            </div>
            <h3>Our Mission</h3>
            <p>
              To deliver world-class automotive fasteners and spare parts through precision manufacturing,
              continuous improvement, and an unwavering commitment to excellence — driving value for
              our customers and partners worldwide.
            </p>
          </div>
        </div>
      </section>

      {/* ── GALLERY ── */}
      {/* <section className="gallery-section">
        <div className="section-header">
          <h2>MANUFACTURING CORE LOCATIONS</h2>
        </div>
        <div className="gallery-grid">
          <div className="gallery-cell wide">
            <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.5" width="52" height="52">
              <rect x="8" y="20" width="28" height="32" rx="2"/>
              <rect x="12" y="24" width="8" height="8" rx="1"/>
              <rect x="24" y="24" width="8" height="8" rx="1"/>
              <rect x="12" y="36" width="20" height="12" rx="1"/>
              <path d="M36 28h12v8H36zM42 20v8M48 36l8-4v16H36V36l6 4"/>
              <path d="M4 52h56"/>
            </svg>
            <span>CNC Machining Complex - Line A</span>
          </div>
          <div className="gallery-cell">
            <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.5" width="52" height="52">
              <path d="M24 8v20L12 48a2 2 0 001.8 2.8h36.4A2 2 0 0052 48L40 28V8"/>
              <path d="M20 8h24M16 38h32"/>
              <circle cx="28" cy="44" r="2"/>
              <circle cx="36" cy="42" r="1.5"/>
            </svg>
            <span>Metallurgical Testing Lab</span>
          </div>
          <div className="gallery-cell tall">
            <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.5" width="52" height="52">
              <rect x="4" y="28" width="36" height="24" rx="2"/>
              <path d="M40 36h12l8 8v8H40V36zM4 36h36"/>
              <path d="M16 28V20a4 4 0 014-4h8a4 4 0 014 4v8"/>
              <circle cx="14" cy="54" r="4"/>
              <circle cx="48" cy="54" r="4"/>
            </svg>
            <span>Global Distribution Logistics Hub</span>
          </div>
          <div className="gallery-cell">
            <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.5" width="52" height="52">
              <circle cx="16" cy="32" r="10"/>
              <circle cx="16" cy="32" r="5"/>
              <circle cx="16" cy="32" r="2"/>
              <path d="M26 32h6M32 28v8"/>
              <path d="M40 20h8v24h-8z"/>
              <path d="M48 28h6a2 2 0 012 2v4a2 2 0 01-2 2h-6"/>
            </svg>
            <span>Automated Wire Drawing Center</span>
          </div>
          <div className="gallery-cell wide">
            <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="1.5" width="52" height="52">
              <path d="M8 44V28l8-8h32l8 8v16H8z"/>
              <path d="M24 44V32h16v12M24 32l-8-12M40 32l8-12"/>
              <circle cx="32" cy="38" r="3"/>
              <path d="M4 44h56"/>
            </svg>
            <span>Precision Die Casting Facility</span>
          </div>
        </div>
      </section> */}

      {/* ── CLOSING STATEMENT ── */}
      <section className="closing-section">
        <div className="closing-inner">
          <h2>Building Strong Relationships<br /><span className="red">Since 1980</span></h2>
          <p>
            We do not believe in competition — we believe in serving our customers better every day.
            Through quality products, fast dispatches, dependable service, and a commitment to excellence,
            we continue to build lasting partnerships with customers across India and around the world.
          </p>
          <div className="closing-highlights">
            {HIGHLIGHTS.map((h, i) => (
              <div className="closing-highlight" key={i}>
                <span className="ch-num">{h.num}</span>
                <span className="ch-text">{h.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}